import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import CustomRoute from './route';
import { MyContextProvider } from './myContext.js';
import './axios.config';

function App() {
  return (
    <MyContextProvider>
      <CustomRoute />
    </MyContextProvider>
  );
}

export default App;
